import ModernTable from "../shared/ModernTable";
import RoundTableRow from "./RoundTableRow";
import SortButton from "../shared/SortButton";
import { RoundResult } from "../../interfaces/ICompetitions";
import { SortDirection } from "../../utils/competitionHelpers";
import { sortRounds } from "../../utils/roundHelpers";
import { useMemo, useState } from "react";

interface RoundsTableProps {
  rounds: RoundResult[];
  competitionId: string;
  categoryId: string;
  onRowClick: (round: RoundResult) => void;
  onBack: () => void;
}

export default function RoundsTable({
  rounds,
  competitionId,
  categoryId,
  onRowClick,
  onBack,
}: RoundsTableProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortDirection, setSortDirection] = useState<SortDirection>("desc");

  const filteredRounds = useMemo(() => {
    let filtered = [...rounds];

    // Sortowanie według specjalnej kolejności rund
    filtered = sortRounds(filtered, sortDirection);

    // Filtrowanie po wyszukiwaniu
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase().trim();
      filtered = filtered.filter((round) => round.name.toLowerCase().includes(term));
    }

    return filtered;
  }, [rounds, searchTerm, sortDirection]);

  const handleSortToggle = () => {
    setSortDirection((prev) => (prev === "desc" ? "asc" : "desc"));
  };

  const columns = [
    {
      id: "round",
      label: "Runda",
      align: "left" as const,
    },
  ];

  return (
    <ModernTable
      data={filteredRounds}
      columns={columns}
      searchPlaceholder="Wyszukaj rundę..."
      onSearch={setSearchTerm}
      searchValue={searchTerm}
      emptyMessage={searchTerm ? "Nie znaleziono rund" : "Brak rund"}
      showBackButton={true}
      onBack={onBack}
      backButtonLabel="Wróć"
      renderRow={(round) => (
        <RoundTableRow round={round} competitionId={competitionId} categoryId={categoryId} />
      )}
      onRowClick={onRowClick}
      getItemKey={(round) => round.roundId}
      headerActions={
        <SortButton
          direction={sortDirection}
          onToggle={handleSortToggle}
          labelDesc="Finał → Eliminacje"
          labelAsc="Eliminacje → Finał"
          tooltipDesc="Sortuj: od finału do eliminacji (kliknij, aby zmienić)"
          tooltipAsc="Sortuj: od eliminacji do finału (kliknij, aby zmienić)"
        />
      }
    />
  );
}

